import ActionsButton from '../../../../components/ui/ActionsButton';
import {EditOutlined, DeleteOutlined} from '@ant-design/icons';
import Badge from '../../../../components/ui/Badge/Badge';

export const trainingSpecialtyConfig = (
    handleDelete,
    setIsPopupOpen,
    setToBeUpdated,
    actionButtonLoading,
    actionButtonDisabled,
    sectionName
) => {
    return (
        {
            dropdown: false,
            dropdownLeftPadding: true,
            greyBackground: true,
            subline: false,
            columnConfig: [
                {
                    label: 'Nom',
                    value: 'type.name',
                    width: 'w-[30%]',
                    sort: true,
                    component: (item) => {
                        return (
                            <div className="flex flex-row items-center justify-center text-left">
                                {item.name}
                            </div>
                        );
                    },
                    sumDisplayed: false,
                    sumBy: '',
                    sumLabel: ''
                },
                {
                    label: 'Code',
                    value: 'type.name',
                    width: 'w-[30%]',
                    sort: true,
                    component: (item) => {
                        return (
                            <div className="flex flex-row items-center justify-center text-center">
                                {item.code}
                            </div>
                        );
                    },
                    sumDisplayed: false,
                    sumBy: '',
                    sumLabel: ''
                },
                {
                    label: 'Statut',
                    value: 'status',
                    width: 'w-[30%]',
                    sort: true,
                    component: (item) => {
                        const invoiceStatus = () => {
                            switch (item.is_active) {
                                case true:
                                    return {status: 'Actif', color: "#CED95F"};
                                case false:
                                    return {status: 'Archivé', color: '#646464'};
                                default:
                                    return {status: 'Indéfini', color: '#212121'};
                            }
                        };

                        return (
                            <div className="flex flex-row items-center justify-center">
                                <Badge content={invoiceStatus().status} color={invoiceStatus().color}/>
                            </div>
                        );
                    },
                    sumDisplayed: false,
                    sumBy: '',
                    sumLabel: ''
                },
                {
                    label: 'Actions',
                    value: null,
                    width: 'w-[10%]',
                    sort: false,
                    component: (item) => {
                        return (
                            <div className="flex flex-row items-center justify-left">
                                {
                                    item.parentStatus === 3 ?
                                        <>
                                            <EditOutlined style={{fontSize: '18px' ,color: '#dfe4ea'}}/>
                                            <div className="w-0 h-0 px-2.5"/>
                                            <DeleteOutlined style={{fontSize: '18px' ,color: '#dfe4ea'}}/>
                                        </> :
                                        <>
                                            <ActionsButton
                                                type="edit"
                                                isLoading={false}
                                                onClick={() => {
                                                    setToBeUpdated(item);
                                                    setIsPopupOpen(true);
                                                }}
                                                disabled={actionButtonDisabled}
                                            />
                                            <div className="w-0 h-0 px-2"/>
                                            <ActionsButton
                                                type="delete"
                                                isLoading={actionButtonLoading === item.id}
                                                onClick={() => handleDelete(item.id)}
                                                disabled={actionButtonDisabled}
                                                deleteConfirmationQuestion={`Souhaitez-vous supprimer ${sectionName.gender === "masculin" ? "ce" : "cette"} ${sectionName.name} ?`}
                                            />
                                        </>
                                }
                            </div>
                        );
                    },
                    sumDisplayed: false,
                    sumBy: '',
                    sumLabel: ''
                }
            ]
        }
    );
};
